import { render, staticRenderFns } from "./NodeEditor.vue?vue&type=template&id=24b2bf1a&scoped=true&"
import script from "./NodeEditor.vue?vue&type=script&lang=js&"
export * from "./NodeEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b2bf1a",
  null
  
)

export default component.exports